/* eslint-disable react/jsx-no-bind */
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as accountActions from '../../actions/accountActions';
import MetaTags from 'react-meta-tags';
import urls from '../../constants/urls.js';
import * as qs from 'query-string';
import PageLoading from '../common/PageLoading';

class ConfirmEmailPage extends React.Component {
    constructor(props, context) {
        super(props, context);
        const params = qs.parse(this.props.location.search);
        this.email = params.email;
        if(this.email) {
            //+'s in the email get replaces with spaces so swap it back
            this.email = this.email.trim().replace(/ /g,'+');
        }
        this.code = params.code;
        this.resendConfirmationEmail = this.resendConfirmationEmail.bind(this);
        this.getMessage = this.getMessage.bind(this);
        this.state = {
            confirmed: this.props.user && this.props.user.Confirmed,
            loading: false,
            resent: false
        };
    }

    componentWillMount() {
        if(this.email && this.code && !this.state.confirmed) {
            this.setState({ loading: true });
            this.props.actions.confirmEmail(this.email, this.code)
                .then(payload => {
                    this.setState({
                        confirmed: true,
                        loading: false
                    });
                })
                .catch(err => {
                    this.setState({
                        confirmed: false,
                        loading: false
                    });
                });
        }
    }

    resendConfirmationEmail(event) {
        event.preventDefault();
        this.props.actions.resendConfirmationEmail(this.email)
            .then(payload => {
                this.setState({
                    resent: true
                });
            })
            .catch(err => {
                this.setState({
                    resent: false
                });
            });
    }

    getMessage() {
        if(this.state.confirmed) {
            return "Thank you, your email address has now been verified";
        }
        else if(!this.state.confirmed && !this.state.loading && this.email && this.code) {
            return "Your email address could not be verified. Please click on the link below to generate a new confirmation email.";
        }
        else if(!this.email || !this.code) {
            let result = 'You need to verify your email address. Please click on the link in the confirmation email we sent';
            if(this.email) {
                result += " or click on the link below to generate a new confirmation email.";
            }
            else {
                result += '.';
            }
            return result;
        }
        else {
            //any other case
            let result = 'Your email address could not be verified.';
            if(this.email) {
                result += ' Please click on the link below to generate a new confirmation email.';
            }
        }
    }

    render() {
        return (
            !this.state.loading ?
                <div className="main">
                    <div className="container">
                        <div className="block-inner">
                            <div className="row">
                                <div className="col-md-12">
                                    <article className="body-copy minimal-height">
                                        <header>
                                            <h1 className="section-alt">Confirm Email</h1>
                                        </header>
                                        <div className="col-sm-6 col-sm-push-3">
                                            {
                                                this.state.resent ?
                                                    <div id="divInfo" className="alert alert-success" style={{fontWeight: 'normal'}}>{`We have resent the confirmation email to ${this.email}`}</div>
                                                : null
                                            }
                                            <p id="pConfirmationMessage" style={{ textAlign: 'center'}}>{this.getMessage()}</p>
                                            {
                                                !this.state.confirmed && !this.state.resent && this.email ?
                                                    <React.Fragment>
                                                        <br />
                                                        <a id="lnkResend" onClick={this.resendConfirmationEmail} href="#">Resend confirmation email</a>
                                                    </React.Fragment>
                                                : null
                                            }
                                            {
                                                !this.props.user && this.state.confirmed ?
                                                    <React.Fragment>
                                                        <br />
                                                        <p>Please <Link to="/Account/Login">click here</Link> to log in</p>  
                                                    </React.Fragment>
                                                : null   
                                            }
                                        </div>
                                    </article>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            :
                <PageLoading />
        );
    }
}

ConfirmEmailPage.propTypes = {
    actions: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    user: PropTypes.object
};

function mapStateToProps(state, ownProps) {
    return { user: state.account.user };
}

function mapDispatchToProps(dispatch) {
    return {
        //account actions will now be available under this.props.actions
        actions: bindActionCreators(Object.assign({}, accountActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmEmailPage);